import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import withReduxProvider from "../../redux-provider";
import { openEmailCaptureOverlay } from "../../../redux/ducks/email-capture-overlay";
import browser from "web/script/utils/browser";

function DesignerExitTrigger({ lystId, openEmailCaptureOverlay, designerName }) {
    useEffect(() => {
        // Trigger should be enabled only on desktop
        if (browser.getViewport() !== browser.VIEWPORTS.DESKTOP) {
            return;
        }

        document.addEventListener("mouseleave", onBodyMouseLeave);
        return () => {
            document.removeEventListener("mouseleave", onBodyMouseLeave);
        };
    });

    function onBodyMouseLeave(event) {
        if (event.clientX > 150 || event.clientY > 50) {
            return;
        }
        // Remove mouseleave event listener so if the user closes the popup, we don't
        // show it again untill they go on another page or refresh the page.
        document.removeEventListener("mouseleave", onBodyMouseLeave);
        const emailCaptureOptions = {
            captureType: "du_popup",
            designerId: lystId,
            designerName: designerName
        };
        openEmailCaptureOverlay(emailCaptureOptions);
    }
    return null;
}

export default withReduxProvider(
    connect(
        null,
        { openEmailCaptureOverlay }
    )(DesignerExitTrigger)
);

DesignerExitTrigger.propTypes = {
    lystId: PropTypes.number,
    designerName: PropTypes.string,
    openEmailCaptureOverlay: PropTypes.func.isRequired
};
